import React from 'react';
import styled from 'styled-components';
const RatioWrapper = styled.div `
  display: block;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  ${props => props.height && `height: ${props.height};`}
`;
const RatioInnerWrapper = styled.div `
  display: block;
  width: 100%;
  height: 100%;
  ${props => props.size && `padding-bottom: ${props.size}%;`}
  ${props => props.width && `width: ${props.width};`}
  ${props => props.height && `height: ${props.height};`}
`;
const RatioImage = styled.div `
  background-position: center;
  background-size: cover;
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;
const RatioChildrenWrapper = styled.div `
  position: relative;
  display: flex;
  height: 100%;
`;
export const Ratio = props => {
    return (React.createElement(RatioWrapper, { height: props.height },
        React.createElement(RatioInnerWrapper, { size: props.size, width: props.width, height: props.height, style: props.style },
            React.createElement(RatioImage, { style: {
                    backgroundImage: `url('${props.bg}')`,
                    backgroundSize: props.bgSize || 'cover',
                    backgroundRepeat: props.bgRepeat
                } },
                React.createElement(RatioChildrenWrapper, { style: props.style }, props.children)))));
};
